import { Translate, useFormController } from '@dreryk/react-common';
import { Form, Notification, NotificationSize, NotificationType, StyledFlex, Toggle } from '@dreryk/react-components';

import { invoicePanelTranslationKeys } from '../translations';

import { useInvoiceFiscalPrintEnableCommand } from './InvoiceFiscalPrintIntegrationToggle.hooks';
import { InvoiceFiscalPrintIntegrationToggleFormBean } from './InvoiceFiscalPrintIntegrationToggle.types';

type InvoiceFiscalPrintIntegrationToggleProps = {
   readonly fiscalPrintIntegrationEnabled: boolean;
};

export const InvoiceFiscalPrintIntegrationToggle = (props: InvoiceFiscalPrintIntegrationToggleProps): JSX.Element => {
   const { register, handleSubmit } = useFormController<InvoiceFiscalPrintIntegrationToggleFormBean>({
      fiscalPrintIntegrationEnabled: props.fiscalPrintIntegrationEnabled,
   });

   const { executeAsync: enableFiscalPrint, loading: enablingFiscalPrint } = useInvoiceFiscalPrintEnableCommand();

   return (
      <Form onInput={handleSubmit(enableFiscalPrint)}>
         <StyledFlex direction={'column'} gap={12}>
            <Toggle
               controller={register('fiscalPrintIntegrationEnabled')}
               testId={'fiscalPrintIntegrationToggle'}
               rightSlot={<Translate>{invoicePanelTranslationKeys.fiscalPrintIntegration.toggleLabel}</Translate>}
               disabled={enablingFiscalPrint}
            />
            <Notification
               label={invoicePanelTranslationKeys.fiscalPrintIntegration.moduleConfigurationRequired}
               testId={'moduleConfigurationRequired'}
               type={NotificationType.INFO}
               size={NotificationSize.SMALLER}
            />
            <Notification
               label={invoicePanelTranslationKeys.fiscalPrintIntegration.privateMedicalServiceConfigurationRequired}
               testId={'privateMedicalServiceConfigurationRequired'}
               type={NotificationType.INFO}
               size={NotificationSize.SMALLER}
            />
         </StyledFlex>
      </Form>
   );
};
